<template>
  <v-dialog v-model="dialog" transition="fade-transition" :width="width">
    <v-card>
      <v-card-title class="headline">{{title}}</v-card-title>
      <v-card-text>
        <v-container class="pa-0">
          <v-row class="no-gutters">
            <v-col cols="12" class="pb-0 pt-0">
              <v-radio-group v-model="place">
                <div v-for="(placeOption, key) in placeOptions" :key="key">
                  <v-radio :label="placeOption.label" :value="key"></v-radio>
                  <div class="pl-8" v-if="key == 'custom' && place == 'custom'">
                       <v-text-field
                        v-model="customPlace"
                        type="number"
                        :label="$t('addPrizeDialog.custom-place-label')"
                        :hint="$t('addPrizeDialog.custom-place-hint')"
                      ></v-text-field>
                  </div>
                </div>
              </v-radio-group>
            </v-col>
            <v-col cols="12">
              <span class="subtitle-1">{{$t('addPrizeDialog.prize')}}</span>
              <v-radio-group v-model="type">
                <div v-for="(typeOption, key) in types" :key="key">
                  <v-radio :label="typeOption.label" :value="key"></v-radio>
                  <div class="pl-8" v-if="type == key">
                    <div v-if="type == 'coins'">
                      <v-text-field
                        append-icon="mdi-circle-multiple-outline"
                        v-model="coins"
                        :rules="coinRule"
                        type="number"
                        filled
                        autocomplete="off"
                      ></v-text-field>
                    </div>
                    <div v-else-if="type == 'custom'">
                      <v-text-field
                        v-model="customText"
                        type="text"
                        :hint="$t('addPrizeDialog.custom-type-hint')"
                        filled
                      ></v-text-field>
                    </div>
                    <div v-else-if="type == 'percentPott'">
                      <v-text-field
                        v-model="percentPott"
                        append-icon="mdi-percent-outline"
                        autocomplete="off"
                        :rules="percentRule"
                        type="text"
                        :hint="$t('addPrizeDialog.percent-pott-type-hint')"
                        filled
                      ></v-text-field>
                    </div>
                  </div>
                </div>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          data-test-id="confirmButton"
          @click="confirm()"
          :disabled="type === undefined || !valid"
          :class="confirmButtonClasses"
        >
          <v-icon left>mdi-check</v-icon>{{ $t("common.ok") }}
        </v-btn>
        <v-btn data-test-id="cancelButton" class="warning" text @click="close()">
          <v-icon left>mdi-close</v-icon>{{ $t("common.cancel") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import envMixin from "@/mixins/envMixin";

export default {
  name: "AddPrizeDialog",
  mixins: [envMixin],
  components: {},
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    editPrize: {
      required: false,
    },
    confirmAction: {
      type: Function,
      required: true,
    },
    confirmButtonClasses: {
      type: String,
      default: "primary",
    },
    closeAction: {
      type: Function,
      required: true,
    },
    initialPlace: {
      type: Number,
      required: false
    },
    width: {
      default: 500,
    },
  },
  data: function () {
    let types = {
      custom: { type: "CUSTOM", label: this.$t('addPrizeDialog.types.custom') }
    };
    if (this.coinsEnabled()) {
      types.coins = { type: "COINS", label: this.$t('addPrizeDialog.types.coins') }
    }
    if (this.coinsEnabled() && this.isSuperUser()) {
      types.percentPott = { type: "PERCENT_FROM_POT", label: this.$t('addPrizeDialog.types.percentPott') }
    }
    var type = undefined
    if (Object.keys(types).length == 1) {
      type = Object.keys(types)[0]
    }
    return {
      dialog: false,
      customText: undefined,
      percentPott: undefined,
      place: undefined,
      customPlace: 4,
      coins: undefined,
      coinRule: [v => parseInt(v) > 0 || ''],
      percentRule: [v => parseFloat(v) > 0 && parseFloat(v) <= 100 || ''],
      types: types,
      placeOptions: {
        1: {label: this.$t('addPrizeDialog.places.1')},
        2: {label: this.$t('addPrizeDialog.places.2')},
        3: {label: this.$t('addPrizeDialog.places.3')},
        custom: {label: this.$t('addPrizeDialog.places.custom')}
      },
      type: type,
      prize: undefined,
    };
  },
  watch: {
    visible: function (val) {
      this.dialog = val;
    },
    dialog: function (val) {
      if (val === false) {
        this.closeAction();
      }
    },
  },
  computed: {
    valid: function() {
      var ret = true
      if (this.place < 1) {
        ret = false;
      }
      if (this.type == 'coins') {
        if (! this.coins || this.coins <= 0) {
          ret = false;
        }
      } else if (this.type == 'custom') {
        if (this.customText === undefined || this.customText.length < 2) {
          ret = false;
        }
      } else if (this.type == 'percentPott') {
        if (isNaN(this.percentPott) || this.percentPott <= 0 || this.percentPott > 100) {
          ret = false;
        }
      }
      return ret
    },
    title: function() {
      if (this.editPrize) {
        return this.$t('addPrizeDialog.edit-title')
      } else {
        return this.$t('addPrizeDialog.title')
      }
    }
  },
  mounted() {
    this.dialog = this.visible;
    // Check if we are editing a prize
    if (this.editPrize) {
      this.setPlace(this.editPrize.place)
      var type
      switch(this.editPrize.type) {
        case 'CUSTOM':
          type = 'custom'
          this.customText = this.editPrize.data.text
          break;
        case 'COINS':
          type = 'coins'
          this.coins = this.editPrize.data.coins
          break
        case 'PERCENT_FROM_POT':
          type = 'percentPott'
          this.percentPott = this.editPrize.data.percent * 100.0
          break
        default:
          type = 'custom';
      }
      this.type = type
    } else if (this.initialPlace) {
      this.setPlace(this.initialPlace)
    }
  },
  methods: {
    confirm() {
      var place = this.place;
      if (place == 'custom') {
        place = this.customPlace;
      }
      place = parseInt(place)
      var prizeData = this.parsePrizeData();
      let newType = this.types[this.type].type;
      if (!newType) {
        throw new Error("prize type could not be evaluated");
      }
      this.prize = { type: newType, place: place, data: prizeData };
      this.close();
      this.confirmAction && this.confirmAction(this.prize);
    },
    parsePrizeData() {
      var prizeData = {};
      if (this.type == "coins") {
        prizeData.coins = parseInt(this.coins);
      } else if (this.type == "custom") {
        prizeData.text = this.customText;
      } else if (this.type == "percentPott") {
        prizeData.percent = this.percentPott / 100.0;
      } else {
        throw new Error('prize type unhandled');
      }
      return prizeData;
    },
    close() {
      this.$emit("input", null);
      this.dialog = false;
    },
    setPlace(place) {
      if (place <= 3) {
        this.place = "" + place
      } else {
        this.place = 'custom'
        this.customPlace = place
      }
    }
  },
};
</script>
<style scoped>
</style>